<div class="row">
  <div class="col-3">
    <select class="form-control" [formControl]="period">
      <option value="7">Last 7 days</option>
      <option value="14">Last 14 days</option>
      <option value="30">Last month</option>
      <option value="90">Last 3 month</option>
      <option value="180">Last 6 month</option>
      <option value="365">Last 12 month</option>
    </select>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <div class="card">
      <div class="card-body">
        <app-line-chart
          [data]="successfulMigrations"
          [type]="'line'"
          [label]="'Successful Migrations'"
          [lineColor]="'#4dbd74'"
          [backgroundColor]="'rgba(77, 189, 116, 0.2)'"
          [isLoading]="isLoadingAccounts"
        >
        </app-line-chart>
      </div>
    </div>
  </div>

  <div class="col-6">
    <div class="card">
      <div class="card-body">
        <app-line-chart
          [data]="failedMigrations"
          [type]="'line'"
          [label]="'Failed Migrations'"
          [lineColor]="'#f86c6b'"
          [backgroundColor]="'rgba(248, 108, 107, 0.2)'"
          [isLoading]="isLoadingAccounts"
        >
        </app-line-chart>
      </div>
    </div>
  </div>
</div>
